import { Pipe, PipeTransform } from '@angular/core';
import { Customer } from '../../classes/customer';

@Pipe({
  name: 'customerCreationDateFilter',
  pure: false
})
export class CustomerCreationDateFilterPipe implements PipeTransform {

  transform(customerList: Array<Customer>, dateFrom: string, dateTo: string): any {
    if (!customerList || (!dateFrom && !dateTo)) {
      return customerList;
    }

    return customerList.filter(customer => {
      if (!customer.CreationDate) {
        return false;
      }

      const creationDate = new Date(customer.CreationDate);
      if (isNaN(creationDate.getTime())) {
        return false;
      }

      if (dateFrom) {
        const fromDate = new Date(dateFrom);
        fromDate.setHours(0, 0, 0, 0);
        if (creationDate < fromDate) {
          return false;
        }
      }

      if (dateTo) {
        const toDate = new Date(dateTo);
        toDate.setHours(23, 59, 59, 999);
        if (creationDate > toDate) {
          return false;
        }
      }

      return true;
    });
  }

}
